import { render, staticRenderFns } from "./RelatorioTelemarketing.vue?vue&type=template&id=71b8ce75&"
import script from "./RelatorioTelemarketing.vue?vue&type=script&lang=js&"
export * from "./RelatorioTelemarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports